import React, { useEffect, useRef, useState } from 'react'
import ProtectedRoute from '../../routes/protected'
import SidebarCargosSalarios from '../../components/sidebars/sidebarCargosSalarios'
import salaryAnalysisService from '../../services/data/salary-analysis.service'
import companyService from '../../services/data/company.service'
import currencyFormat from '../../helpers/currencyFormat'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Toast } from 'primereact/toast'
import { Dropdown } from 'primereact/dropdown'
import { Sidebar } from 'primereact/sidebar'
import moment from 'moment'
import 'moment/locale/pt-br'

export default function Orcamento() {
    const [budgets, setBudgets] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')
    const [showForm, setShowForm] = useState(false)
    const toast = useRef(null)

    const [subcompanySel, setSubcompanySel] = useState(null)
    const [subcompanyItems, setSubcompanyItems] = useState([])
    const [departmentSel, setDepartmentSel] = useState(null)
    const [departmentItems, setDepartmentItems] = useState([])

    const [form, setForm] = useState({
        subcompany_id: '', department_id: '', costcenter_id: '',
        period_start: '', period_end: '', approved_amount: ''
    })
    const [formSubcompanySel, setFormSubcompanySel] = useState(null)
    const [formSubcompanyItems, setFormSubcompanyItems] = useState([])
    const [formDepartmentSel, setFormDepartmentSel] = useState(null)
    const [formDepartmentItems, setFormDepartmentItems] = useState([])

    function loadBudgets(filters = {}) {
        setLoading(true)
        salaryAnalysisService.listOrcamento(filters)
            .then(setBudgets)
            .catch(e => setError(JSON.stringify(e?.response?.data || e)))
            .finally(() => setLoading(false))
    }

    useEffect(() => { loadBudgets() }, [])
    useEffect(() => {
        companyService.autoCompleteSubCompany('')
            .then(r => setSubcompanyItems(r || []))
            .catch(() => setSubcompanyItems([]))
        companyService.autoCompleteDepartment('')
            .then(r => setDepartmentItems(r || []))
            .catch(() => setDepartmentItems([]))
    }, [])

    function applyFilters() {
        const f = {}
        if (subcompanySel) f.subcompany_id = subcompanySel.id
        if (departmentSel) f.department_id = departmentSel.id
        loadBudgets(f)
    }

    function loadFormScopeOptions(selectedSubcompany = null) {
        salaryAnalysisService.getOrcamentoScopeOptions(selectedSubcompany?.id || null)
            .then(r => {
                setFormSubcompanyItems(r?.subcompanies || [])
                setFormDepartmentItems(r?.departments || [])
            })
            .catch(() => {
                setFormSubcompanyItems([])
                setFormDepartmentItems([])
            })
    }

    useEffect(() => {
        if (!showForm) return
        loadFormScopeOptions(formSubcompanySel)
    }, [showForm, formSubcompanySel])

    function handleFormChange(field, val) {
        setForm(prev => ({ ...prev, [field]: val }))
    }

    function submitForm(e) {
        e.preventDefault()
        if (!formSubcompanySel) {
            toast.current.show({ severity: 'warn', summary: 'Campo obrigatório', detail: 'Selecione a organização.', life: 3000 })
            return
        }
        if (!formDepartmentSel) {
            toast.current.show({ severity: 'warn', summary: 'Campo obrigatório', detail: 'Selecione o departamento.', life: 3000 })
            return
        }

        const data = {
            ...form,
            subcompany_id: formSubcompanySel?.id || null,
            department_id: formDepartmentSel?.id || null,
        }
        salaryAnalysisService.createOrcamento(data)
            .then(() => {
                toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Orçamento criado!', life: 3000 })
                setShowForm(false)
                setForm({ subcompany_id: '', department_id: '', costcenter_id: '', period_start: '', period_end: '', approved_amount: '' })
                setFormSubcompanySel(null); setFormDepartmentSel(null)
                loadBudgets()
            })
            .catch(e => toast.current.show({ severity: 'error', summary: 'Erro', detail: JSON.stringify(e?.response?.data || e), life: 6000 }))
    }

    function deleteBudget(id) {
        if (!window.confirm('Remover este orçamento?')) return
        salaryAnalysisService.deleteOrcamento(id)
            .then(() => {
                toast.current.show({ severity: 'success', summary: 'Removido', detail: 'Orçamento removido.', life: 3000 })
                loadBudgets()
            })
            .catch(e => toast.current.show({ severity: 'error', summary: 'Erro', detail: JSON.stringify(e?.response?.data || e), life: 6000 }))
    }

    return (
        <ProtectedRoute>
            <Toast ref={toast} position="top-right" />
            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <SidebarCargosSalarios />
                    <div className="col-xs-10 col-sm-9 col-md-9 col-xl-10 p-0 formMarginBottom">
                        <div className='col text-bg-green p-3'>
                            <span className="fs-6 fw-bold">Orçamento de Posições</span>
                        </div>

                        <div className='m-3'>
                            <div className='p-3'>
                                Nesta tela você define o orçamento salarial por organização e departamento
                                em um período. Com esses valores, o sistema compara o gasto real de salários com o orçamento aprovado para
                                mostrar o percentual de utilização e apoiar decisões de contratação e enquadramento.
                            </div>
                        </div>

                        {/* Filtros + botão novo */}
                        <div className='row m-3 g-2 align-items-end'>
                            <div className='col-md-3'>
                                <label className='form-label small fw-bold'>Organização</label>
                                <Dropdown className='w-100' placeholder='Organização'
                                    value={subcompanySel}
                                    options={subcompanyItems}
                                    optionLabel='title'
                                    filter
                                    showClear
                                    onChange={e => setSubcompanySel(e.value)} />
                            </div>
                            <div className='col-md-3'>
                                <label className='form-label small fw-bold'>Departamento</label>
                                <Dropdown className='w-100' placeholder='Departamento'
                                    value={departmentSel}
                                    options={departmentItems}
                                    optionLabel='title'
                                    filter
                                    showClear
                                    onChange={e => setDepartmentSel(e.value)} />
                            </div>
                            <div className='col-auto'>
                                <button className='btn btn-success btn-sm' onClick={applyFilters}>
                                    <FontAwesomeIcon icon={solid('magnifying-glass')} /> Filtrar
                                </button>
                            </div>
                            <div className='col-auto'>
                                <button className='btn btn-link btn-sm text-grey text-decoration-none'
                                    onClick={() => { setSubcompanySel(null); setDepartmentSel(null); loadBudgets() }}>
                                    Limpar
                                </button>
                            </div>
                            { budgets.length > 0 && (
                                <div className='col-auto ms-auto'>
                                    <button className='btn btn-success btn-sm rounded-pill' onClick={() => setShowForm(!showForm)}>
                                        <FontAwesomeIcon icon={solid('plus')} /> Novo Orçamento
                                    </button>
                                </div>
                            )}
                        </div>

                        <Sidebar
                            visible={showForm}
                            position="right"
                            style={{ width: '42rem', maxWidth: '95vw' }}
                            onHide={() => setShowForm(false)}
                            header={<span className='fw-bold'>Novo Orçamento</span>}
                        >
                            <form onSubmit={submitForm}>
                                <div className='row g-3'>
                                    <div className='col-12'>
                                        <label className='form-label small fw-bold'>Organização</label>
                                        <Dropdown className='w-100' placeholder='Organização'
                                            value={formSubcompanySel}
                                            options={formSubcompanyItems}
                                            optionLabel='title'
                                            filter
                                            showClear
                                            appendTo='self'
                                            scrollHeight='260px'
                                            onChange={e => {
                                                setFormSubcompanySel(e.value || null)
                                                setFormDepartmentSel(null)
                                            }} />
                                    </div>
                                    <div className='col-12'>
                                        <label className='form-label small fw-bold'>Departamento</label>
                                        <Dropdown className='w-100' placeholder='Departamento'
                                            value={formDepartmentSel}
                                            options={formDepartmentItems}
                                            optionLabel='title'
                                            filter
                                            showClear
                                            appendTo='self'
                                            scrollHeight='260px'
                                            onChange={e => setFormDepartmentSel(e.value || null)} />
                                    </div>
                                    <div className='col-12'>
                                        <label className='form-label small fw-bold'>Valor Aprovado (R$)</label>
                                        <input type='number' step='0.01' className='form-control form-control-sm'
                                            value={form.approved_amount}
                                            onChange={e => handleFormChange('approved_amount', e.target.value)} required />
                                    </div>
                                    <div className='col-md-6'>
                                        <label className='form-label small fw-bold'>Início do Período</label>
                                        <input type='date' className='form-control form-control-sm'
                                            value={form.period_start}
                                            onChange={e => handleFormChange('period_start', e.target.value)} required />
                                    </div>
                                    <div className='col-md-6'>
                                        <label className='form-label small fw-bold'>Fim do Período</label>
                                        <input type='date' className='form-control form-control-sm'
                                            value={form.period_end}
                                            onChange={e => handleFormChange('period_end', e.target.value)} required />
                                    </div>
                                </div>
                                <div className='mt-4 d-flex gap-2'>
                                    <button type='submit' className='btn btn-success btn-sm'>Salvar</button>
                                    <button type='button' className='btn btn-secondary btn-sm' onClick={() => setShowForm(false)}>Cancelar</button>
                                </div>
                            </form>
                        </Sidebar>

                        {error && <div className='alert alert-danger mx-3'>{error}</div>}

                        <div className='row m-3'>
                            <div className='col bg-white border-clean pb-4'>
                                {loading && (
                                    <div className='text-center p-4'>
                                        <div className="spinner-border text-success" role="status" />
                                    </div>
                                )}
                                {!loading && budgets.length === 0 && (
                                    <>
                                    <p className='text-center text-muted py-4'>Nenhum orçamento cadastrado.</p>
                                    <div className='text-center'>
                                        <button className='btn btn-success rounded-pill' onClick={() => setShowForm(!showForm)}>
                                            <FontAwesomeIcon icon={solid('plus')} /> Novo Orçamento
                                        </button>
                                        </div>
                                    </>
                                )}
                                {!loading && budgets.length > 0 && (
                                    <table className='table table-borderless thover borderBottom mt-3'>
                                        <thead className='borderBottom'>
                                            <tr>
                                                <th>Organização</th>
                                                <th>Departamento</th>
                                                <th>Período</th>
                                                <th className='text-end'>Valor Aprovado</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {budgets.map((b, i) => (
                                                <tr key={i}>
                                                    <td className='align-middle'>{b.subcompany_title || '-'}</td>
                                                    <td className='align-middle'>{b.department_title || '-'}</td>
                                                    <td className='align-middle small'>
                                                        {moment(b.period_start).format('MMM/YYYY')} — {moment(b.period_end).format('MMM/YYYY')}
                                                    </td>
                                                    <td className='align-middle text-end fw-bold'>{currencyFormat(b.approved_amount)}</td>
                                                    <td className='align-middle text-end'>
                                                        <button className='btn btn-sm btn-link text-danger' onClick={() => deleteBudget(b.id)}>
                                                            <FontAwesomeIcon icon={solid('trash')} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}
